export function areAllSubstringsInValues(substrings: Array<string>, values: Array<string>) {
  return substrings.every((substring) => values.some((value) => value.toString().toLowerCase().indexOf(substring) >= 0));
}
